import { useTranslation, Trans} from 'react-i18next';
import { useEffect, useState } from 'react';
import { format } from 'react-string-format';
import '../../../i18n';
import ReactHtmlParser from 'html-react-parser';

import Button from '../../UI/Buttons/Button';
import { useParams } from 'react-router';
import { APIPost } from '../../API/APIRequest';
import { getFormattedDate } from '../../Utilities/HelperFunctions';
import DOMPurify from 'dompurify';
export function RetentionOfferAcceptance(props) {

    const { t, i18n } = useTranslation();
    const {handlePageChange, 
        termsText, 
        setErrors,
        isDiscountApplied,
        showAddedTax,
        frequencyText,
        variantId,
        discountId,
        cardNumber,
        accountNumber,
        cardTypeName,
        startDate,
        prevPriceValue,
        frequencyInMonths,
        paymentType,
        freqDescription
       } = props;

    const [isLoading, setIsLoading] = useState(false);
    const { fid } = useParams();

    
  const acceptAlternateOffer = () => {
        
        setIsLoading(true);
        const payload = {"fid": fid, "NewVariantId": variantId , "DiscountId" : discountId}
        
        APIPost({

            "controller": "order",
            "action": "acceptalternativeoffer",
            "data": payload,
            "content_type": "json"

        })
            .then((response) => {
            
                console.log("offerAcceptance", response?.data);
                handlePageChange("THANKYOU_PAGE")

            }).catch((error) => {
            
               var unexpected = [];
               unexpected.push("error.unexpected");
               setErrors(unexpected);  //error handling
               console.log("An error occured while accepting the offer")
               setIsLoading(false);
            })
    }
    
    return (
        <div className="container  center-text ">

            <div className="item-container">
                <h1 class="block-header" tabindex="-1">{t('retentionoffer.confirmdetails')} </h1>
            </div>

            <div className="item-container">
                <div className="item-wrapper">
                    <p className="small-text">{t('retentionoffer.subsstartontext')} </p>
                    <p className="xxlarge"> <strong>{startDate}</strong></p>
                </div>
            </div>

            <div className="item-container">
                <div className="border-seperator"></div>
            </div>

            <div className="item-container ">
                <div className="item-wrapper" >
                    {paymentType === "DirectDebit" ? <p>{t('retentionoffer.chargeyouraccounttext')}</p> : <p>{t('retentionoffer.chargeyourcardtext')}</p>}

                    {isDiscountApplied  ? <p>{frequencyText}</p> : <strong>{prevPriceValue}{freqDescription}{showAddedTax && t('retentionoffer.addedtaxstring')}</strong> }
                   
                </div>
                        
                <div className="item-wrapper center-flex-row" >
                    {paymentType === "DirectDebit" ?
                        <div className="box-border">
                            <div className="payment-method">
                                <img src={`/assets/paymenttypes/logos/` + "directdebit" + `.svg`}
                                    alt="logo" />
                            </div>
                            <strong>xxxxx{accountNumber}</strong>
                        </div> :
                        (cardTypeName?.toLowerCase() === "link") ?
                        <div className="box-border">
                            <div className="payment-method">
                                <img src={`/assets/paymenttypes/logos/link.svg`}
                                    alt="Link Payment" />
                            </div>
                            <strong>Link Payment</strong>
                        </div> :
                        <div className="box-border">
                            <div className="payment-method">
                                <img src={`/assets/paymenttypes/logos/` + cardTypeName + `.svg`}
                                    alt="logo" />
                            </div>
                            <strong>xxxx xxxx xxxx {cardNumber}</strong>
                        </div>
                    }
                </div>

                <div className="item-wrapper" >
                   <p className="meta">{ReactHtmlParser(DOMPurify.sanitize(termsText || ""))}</p>
                 </div>
             
            </div>

            <div className="item-container">
                <div className="item-wrapper center-flex-row">
                    <Button type="button" buttonSize="medium" btnType="ghost" onClick={()=>{handlePageChange("RETENTION_OFFER")}}>{t('retentionofferacceptance.cancelbuttontext')}</Button>
                    {isLoading ? <Button type="button" buttonSize="medium" hasIcon="updating">{t('retentionoffer.confirmofferbuttontext')} </Button> :
                    <Button type="button" buttonSize="medium" onClick={()=>{ acceptAlternateOffer()}}>{t('retentionoffer.confirmofferbuttontext')}</Button>}
                </div>
            </div>
        </div>

    );
}